import { poolsService } from 'services/poolsService';
import { Meta } from 'types/pagination';
import { PoolBase } from 'types/pool';
import { SidebarSortingFilters } from 'views/admin/poolsList/components/SortingFilter/types/sortingFilters';

export const fetchPoolsData = async ({
  page,
  pools,
  setPools,
  setPoolsMeta,
	filters,
	search,
	creator_address,
	networkId
}: {
  page?: number;
  pools: PoolBase[];
  setPools(pools: PoolBase[]): void;
  setPoolsMeta(meta: Meta | undefined): void;
	filters?: SidebarSortingFilters;
	search?: string;
	creator_address?: string;
	networkId?: string;
}) => {
	if (!networkId) return;

  try {
    const poolsData = await poolsService.getPools({
      page,
			filters,
			search,
			creator_address,
			networkId,
    });

    setPools(poolsData.data);

    setPoolsMeta(poolsData.meta);
  } catch (error) {
		setPools([])
		setPoolsMeta(undefined)
    console.error(error);
  }
};
